import BehavioralPatternGraph from 'Shared/components/BehavioralPatternGraph/BehavioralPatternGraph';
import BehavioralPatternShape from 'Shared/components/BehavioralPatternGraph/BehavioralPatternShape';
import {
  BAFactorShapeType,
  BehavioralPatternGraphType,
} from 'Shared/components/BehavioralPatternGraph/FactorShape.service';
import { useBaProfile } from 'Shared/utils/hooks/use-ba-profile';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpDivider } from 'Wpds/components/divider';
import React from 'react';
import './CombinedRelationship.scss';

type Props = {
  useFullHeight?: boolean;
};

function CombinedRelationship({ useFullHeight }: Props): JSX.Element {
  const { otherUserInOneOnOne } = useWorkspace();
  const { user } = useCurrentUser();
  const { baProfile, isFetching: userIsFetching } = useBaProfile({ user });
  const { baProfile: otherBaProfile, isFetching: otherUserIsFetching } = useBaProfile({ user: otherUserInOneOnOne });

  const baseClassName = 'CombinedRelationship';

  const graphType = BehavioralPatternGraphType.Standard;

  return (
    !(userIsFetching || otherUserIsFetching) &&
    baProfile &&
    otherBaProfile && (
      <WpContainer className={`${baseClassName}${useFullHeight ? '--full-height' : ''}`}>
        <WpContainerBody
          className={`${baseClassName}__body ${useFullHeight ? `${baseClassName}--full-height` : ''}`}
          padding={32}
        >
          <div className={`${baseClassName}__all-except-legend`}>
            <p className={`${baseClassName}__header`}>
              Use data to compare your behavioral drives with {otherUserInOneOnOne.firstName}&apos;s. See where you
              align and differ, so you manage conflict and improve collaboration.
            </p>
            <WpDivider />
            <div className={useFullHeight ? `${baseClassName}--extra-margin-top` : ''}>
              <BehavioralPatternGraph
                graphType={graphType}
                baPersonInfo={baProfile}
                otherBAPersonInfo={otherBaProfile}
                useConnectingLine={true}
                useBarDescriptions={true}
              />
            </div>
          </div>
          <div className={`${baseClassName}__legend`}>
            {/* Separate spans are used so that if the UI is constrained for space, the `=` gets centered */}
            <div className={`${baseClassName}__legend-item`}>
              <BehavioralPatternShape graphType={graphType} shapeType={BAFactorShapeType.Circle} />
              <span>=</span>
              <span>{otherUserInOneOnOne.firstName}</span>
            </div>
            <div className={`${baseClassName}__legend-item`}>
              <BehavioralPatternShape graphType={graphType} shapeType={BAFactorShapeType.Square} />
              <span>=</span>
              <span>{user.first_name}</span>
            </div>
          </div>
        </WpContainerBody>
      </WpContainer>
    )
  );
}

export default CombinedRelationship;
